export default {
  init() {
    $('.input#keyword').on('input', function() {
      if ($(this).val().length) {
        $("#datafetch").show();
      } else {
        $("#datafetch").hide();
      }
    });

    $('#filter').change(function() {
      var filter = $('#filter');
      $.ajax({
        url:filter.attr('action'),
          data:filter.serialize(), // form data
          type:filter.attr('method'), // POST
          beforeSend:function(xhr) {
            // filter.find('button span').text('Processing...'); // changing the button label
          },
          success:function(data) {
            // filter.find('button span').text('Search'); // changing the button label back
            $('.base-results').hide();
            $('#datafetch').html(data); // insert data
          },
        });
      return false;
    });

    $(window).keydown(function(event){
      if(event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchivePtc_vendors.js